import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import {
  Box,
  useTheme,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import axios from "axios";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { getAllServices } from "../../../services/Services";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "التحويلات الواردة",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Calculation_profit = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Profit, setProfit] = useState("");
  const [datefrom, setDateFrom] = useState();
  const [dateto, setDateTo] = useState();
  const [ServicesData, setServices] = useState([]);

  const [personName, setPersonName] = React.useState([]);
  const [orderType, setOrderType] = useState([]);



  const type_order = [
    { id: "paid", title: "مدفوع" },
    { id: "unpaid", title: "غير مدفوع" },
  ];
  // const handleChange = (event) => {
  //   const value = event.target.value;
  //   // Toggle selection for a given value
  //   const currentIndex = orderType.indexOf(value);
  //   const newChecked = [...orderType];

  //   if (currentIndex === -1) {
  //     newChecked.push(value);
  //   } else {
  //     newChecked.splice(currentIndex, 1);
  //   }

  //   setOrderType(newChecked);
  // };
  const handleChange = (event) => {
        const value = event.target.value;
    if (event.target.name === "fund_name") {
      // 'value' will be the selected item IDs, so set 'personName' to these IDs
      setPersonName(typeof value === "string" ? value.split(",") : value);
    }
    if (event.target.name === "order_type") {
    // Directly use the array from the event's target value
    setOrderType(event.target.value);
};
};
  // const handleChange = (event) => {
  //   const value = event.target.value;
  //   if (event.target.name === "fund_name") {
  //     // 'value' will be the selected item IDs, so set 'personName' to these IDs
  //     setPersonName(typeof value === "string" ? value.split(",") : value);
  //   }
  //   if (event.target.name === "order_type") {
  //     // setOrderType(event.target.value);
  //     const value = event.target.value;
  //     const currentIndex = orderType.indexOf(value);
  //     const newChecked = [...orderType];
  
  //     if (currentIndex === -1) {
  //       newChecked.push(value);
  //     } else {
  //       newChecked.splice(currentIndex, 1);
  //     }
  
  //     setOrderType(newChecked);
  //   };
  
  //   //     if (personName == "") {
  //   //       const selectedOptions = event.target.value;
  //   //       axios
  //   //         .get(`${BaseUrl}/api/getAllTransactionforMe`, {
  //   //           withCredentials: true,
  //   //         })
  //   //         .then((res) => {
  //   //           const filteredData = res.data.data.filter((row) =>
  //   //             selectedOptions.includes(row.code_name)
  //   //           );
  //   //           setUsers(filteredData);
  //   //           setIsLoading(false);
  //   //         })
  //   //         .catch((error) => {
  //   //           setIsLoading(false);
  //   //         });
  //   //     } else {
  //   //       const selectedOptions = event.target.value;
  //   //       const order_type = personName;
  //   //       axios
  //   //         .get(`${BaseUrl}/api/getAllTransactionforMe`, {
  //   //           withCredentials: true,
  //   //         })
  //   //         .then((res) => {
  //   //           const filteredData = res.data.data.filter(
  //   //             (row) =>
  //   //               selectedOptions.includes(row.code_name) &&
  //   //               order_type.includes(row.fund_name)
  //   //           );
  //   //           setUsers(filteredData);
  //   //           setIsLoading(false);
  //   //         })
  //   //         .catch((error) => {
  //   //           setIsLoading(false);
  //   //         });
  //   //     }
  //   //   }
  // };
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  
  useEffect(() => {}, [Profit]);
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${BaseUrl}/api/getallfund`, {
        withCredentials: true,
      })
      .then((res) => {
        setUsers(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });
      getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });
    return () => {};
  }, []);
  const handleDateFromChange = (event) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event) => {
    setDateTo(event.target.value);
  };
  const handleSubmit = async (e) => {

    if (personName.length == 0) {
      sweetalert("يجب إختيار احد الارصدة على الاقل للاستعلام عنه", {
        className: "alert-div",
        button: {
          text: "تم",
        },
      });
    } else if (orderType == "") {
      sweetalert("نوع الربح مطلوب", {
        className: "alert-div",
        button: {
          text: "تم",
        },
      });
    } else {
      setLoading(true);
      const data = {
        order_type: orderType,
        fund_type: personName,
        from_date: datefrom,
        to_date: dateto,
      };
      const response = await axios.post(
        `${BaseUrl}/api/calculateProfit`,
        data,
        {
          withCredentials: true,
        }
      ).then((response) => {

      if (response.data.status === true) {
        setLoading(false);
        setProfit(response.data.data);
      }
    }).catch((err) => {
      if (err.response && err.response.status === 500) {
        sweetalert(err.response.msg, {
          className: "alert-div",
          button: {
            text: "تم",
          },
        });
      }
    });
  };
  };
  return (
    <Box m="2px 5px 0px 5px">
      <Header />
      {ServicesData[8]?.name == "Profits" &&
      ServicesData[8]?.is_active == 1 ? (
        <>

     
      <Box
        m="40px 0 0 0"
        height="15vh"
        width="100%"
        className="box-date-filter"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "15px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "15px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <>
        <div className='divfilter'>
          <FormControl style={{  marginRight: "20px" }}>
            <InputLabel
              id="demo-mutiple-checkbox-label"
              style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
            >
              فلترة حسب اسم الرصيد
            </InputLabel>
            <Select
              multiple
              value={personName} // This should be an array of selected item IDs
              onChange={handleChange}
              input={<Input />}
              renderValue={(selected) =>
                selected
                  .map((id) => {
                    const match = users.find((user) => user.id === id);
                    return match ? match.fund_name : null; // Only return fund_name if a match is found
                  })
                  .filter((name) => name !== null) // Filter out any nulls resulting from no match
                  .join(", ")
              }
              name="fund_name"
            >
              {users.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  <Checkbox checked={personName.indexOf(user.id) > -1} />
                  <ListItemText primary={user.fund_name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* <FormControl style={{  marginRight: "20px" }}>
            <InputLabel
              id="demo-mutiple-checkbox-label1"
              style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
            >
              فلترة حسب نوع الربح
            </InputLabel>
            <Select
              value={orderType}
              onChange={handleChange}
              input={<Input />}
              name="order_type"
            >
              {type_order.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <FormControl style={{ marginRight: "20px" }}>
            <InputLabel id="demo-multiple-checkbox-label" style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}>
                فلترة حسب نوع الربح
            </InputLabel>
            <Select
                labelId="demo-multiple-checkbox-label"
                multiple
                value={orderType}
                name='order_type'
                onChange={handleChange}
                renderValue={(selected) => selected.map(id => {
                    const foundItem = type_order.find(o => o.id === id);
                    return foundItem ? foundItem.title : 'Unknown';
                }).join(', ')}
            >
                {type_order.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        <Checkbox checked={orderType.includes(option.id)} />
                        <ListItemText primary={option.title} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
          </div>
          <div className='divdate'>
          <div className='dateFrom'>
        <label htmlFor="dateFrom">من تاريخ:</label>
        <input
          id="dateFrom"
          type='date'
          value={datefrom}
          onChange={handleDateFromChange}
        />
      </div>
      <div className='dateTo'>
        <label htmlFor="dateTo">إلى تاريخ:</label>
        <input
          id="dateTo"
          type='date'
          value={dateto}
          onChange={handleDateToChange}
        />
      </div>
      </div>
        </>
      </Box>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <img
          src="pngtree-income-salary-dollar-rate-increase-statistic-business-profit-growth-margin-revenue-png-image_1744860.png"
          alt="profit"
          style={{
            width: "50%",
            height: "40vh",
            display: "flex",
            justifyContent: "center",
          }}
        />
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
  
          <Grid item md={6} xs={12}  class="div-btn-submit">
            {loading === true ? (
              <Controls.Button
                text=<div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div>
                variant="contained"
                className="btn-submit"
              ></Controls.Button>
            ) : (
              <Controls.Button
                type="submit"
                text="إستعلام"
                onClick={handleSubmit}
                variant="contained"
                className="btn-submit"
              ></Controls.Button>
            )}
          </Grid>
          <Grid
            container
            maxWidth="sm"
            
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item md={6} xs={12}>
              <Controls.Input
                label=""
                name="first_name"
                fullWidth
                value={Profit}
                className="form-control"
                type="text"
                disabled
              />
            </Grid>
          </Grid>
      
      </div>
      </>
      ) : ServicesData[8]?.name == "Profits" &&
        ServicesData[8]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563"? (
                    <>

     
<Box
  m="40px 0 0 0"
  height="15vh"
  width="100%"
  className="box-date-filter"
  sx={{
    "& .MuiDataGrid-root": {
      border: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "none",
    },
    "& .name-column--cell": {
      color: colors.redAccent[1100],
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: colors.redAccent[1100],
      borderBottom: "none",
      fontSize: "15px !important",
    },
    "& .MuiDataGrid-cellContent": {
      fontSize: "15px !important",
      color: `${colors.grey[600]} !important`,
    },
    "& .MuiDataGrid-virtualScroller": {
      backgroundColor: colors.white[100],
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "none",
      backgroundColor: colors.redAccent[1100],
    },
    "& .MuiCheckbox-root": {
      color: `${colors.greenAccent[200]} !important`,
    },
  }}
>
  <>
  <div className='divfilter'>
    <FormControl style={{  marginRight: "20px" }}>
      <InputLabel
        id="demo-mutiple-checkbox-label"
        style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
      >
        فلترة حسب اسم الرصيد
      </InputLabel>
      <Select
        multiple
        value={personName} // This should be an array of selected item IDs
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) =>
          selected
            .map((id) => {
              const match = users.find((user) => user.id === id);
              return match ? match.fund_name : null; // Only return fund_name if a match is found
            })
            .filter((name) => name !== null) // Filter out any nulls resulting from no match
            .join(", ")
        }
        name="fund_name"
      >
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            <Checkbox checked={personName.indexOf(user.id) > -1} />
            <ListItemText primary={user.fund_name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {/* <FormControl style={{  marginRight: "20px" }}>
      <InputLabel
        id="demo-mutiple-checkbox-label1"
        style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
      >
        فلترة حسب نوع الربح
      </InputLabel>
      <Select
        value={orderType}
        onChange={handleChange}
        input={<Input />}
        name="order_type"
      >
        {type_order.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}
    <FormControl style={{ marginRight: "20px" }}>
      <InputLabel id="demo-multiple-checkbox-label" style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}>
          فلترة حسب نوع الربح
      </InputLabel>
      <Select
          labelId="demo-multiple-checkbox-label"
          multiple
          value={orderType}
          name='order_type'
          onChange={handleChange}
          renderValue={(selected) => selected.map(id => {
              const foundItem = type_order.find(o => o.id === id);
              return foundItem ? foundItem.title : 'Unknown';
          }).join(', ')}
      >
          {type_order.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                  <Checkbox checked={orderType.includes(option.id)} />
                  <ListItemText primary={option.title} />
              </MenuItem>
          ))}
      </Select>
  </FormControl>
    </div>
    <div className='divdate'>
    <div className='dateFrom'>
  <label htmlFor="dateFrom">من تاريخ:</label>
  <input
    id="dateFrom"
    type='date'
    value={datefrom}
    onChange={handleDateFromChange}
  />
</div>
<div className='dateTo'>
  <label htmlFor="dateTo">إلى تاريخ:</label>
  <input
    id="dateTo"
    type='date'
    value={dateto}
    onChange={handleDateToChange}
  />
</div>
</div>
  </>
</Box>
<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
  <img
    src="pngtree-income-salary-dollar-rate-increase-statistic-business-profit-growth-margin-revenue-png-image_1744860.png"
    alt="profit"
    style={{
      width: "50%",
      height: "40vh",
      display: "flex",
      justifyContent: "center",
    }}
  />
</div>
<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>

    <Grid item md={6} xs={12}  class="div-btn-submit">
      {loading === true ? (
        <Controls.Button
          text=<div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
          </div>
          variant="contained"
          className="btn-submit"
        ></Controls.Button>
      ) : (
        <Controls.Button
          type="submit"
          text="إستعلام"
          onClick={handleSubmit}
          variant="contained"
          className="btn-submit"
        ></Controls.Button>
      )}
    </Grid>
    <Grid
      container
      maxWidth="sm"
      
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid item md={6} xs={12}>
        <Controls.Input
          label=""
          name="first_name"
          fullWidth
          value={Profit}
          className="form-control"
          type="text"
          disabled
        />
      </Grid>
    </Grid>

</div>
</>
      ) : 
       ServicesData[8]?.name == "Profits" &&
        ServicesData[8]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default Calculation_profit;
